import { useGetAccountGroupsOptions } from '../../../../../queries';
import { t } from 'i18next';
import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';
import { nestedFieldValueGetter } from 'components/shared/DataGrid/utils/valueGetters/nestedFieldValueGetter';
import { dateFormatter } from 'components/shared/DataGrid/utils/valueFormatters/dateFormatter';

export const useGetAccountGroupsColumns = () => {
  const { data: options } = useGetAccountGroupsOptions();

  return [
    {
      field: 'groupId',
      type: 'singleSelect',
      headerName: t('groupName'),
      valueOptions: options,
      valueFormatter: (params) =>
        singleSelectValueFormatter(params, options ?? []),
      flex: 2
    },
    {
      field: 'valid.from',
      type: 'date',
      headerName: t('validFrom'),
      valueGetter: nestedFieldValueGetter,
      valueFormatter: dateFormatter,
      minWidth: 120,
      flex: 1
    },
    {
      field: 'valid.to',
      type: 'date',
      headerName: t('validTo'),
      valueGetter: nestedFieldValueGetter,
      valueFormatter: dateFormatter,
      minWidth: 120,
      flex: 1
    }
  ];
};
